'use strict';

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.fn.formatTime = function (format, formatWithoutMinutes) {
  if (this.minute() === 0) {
    return this.format(formatWithoutMinutes);
  }
  return this.format(format);
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/initialize.js
// module id = 702
// module chunks = 0